import { useContext } from 'react'
import { PfpContext } from '../contexts/PfpContext'

// ----------------------------------------------------------------------

const usePfp = () => {
	const context = useContext(PfpContext)

	if (!context) throw new Error('Pfp context must be use inside PfpProvider')

	return context
}

export default usePfp
